<div class="hero">
  <div class="position-relative">
    <video class="hero-img" autoplay [muted]="true" loop playsinline>
      <source [src]="imageUrl + config.heroVideoUrl" type="video/mp4" />
      Your browser does not support the video tag.
    </video>

    <div class="content px-3 px-md-5 text-white">
      <h1 class="seconed-title">
        {{ appModeService.isApp()
        ? ('SELECT_YOUR_UNIQUE_OUTFIT' | translate)
        : (config.heroHeaderText || 'CUSTOMIZE YOUR OUTFIT')
        }}
      </h1>

      <p class="hero-desc">
        {{ appModeService.isApp()
        ? ('TRY_A_UNIQUE_EXPERIENCE' | translate)
        : (config.heroParagraphText || 'Try a unique experience and start creating your own outfit design.')
        }}
      </p>

      <button id="getStartedButton" class="btn customize-btn mt-3 mt-sm-4" routerLink="/customization">
        {{ appModeService.isApp()
        ? ('SHOP_NOW' | translate)
        : (config.heroButtonText || 'GET STARTED!')
        }}
      </button>
    </div>
  </div>
</div>